export default __webpack_public_path__ + "static/media/E-Commerce 3.b9cf8c79.svg";